// external dependencies
import React, { useContext } from 'react'
import { SearchContext } from '../SearchProvider'
import styled from '@emotion/styled'

// components
import AdditionalItem from './AdditionalItem'
import ResourceSection from './ResourceSection'

const AdditionalResourceArticle = styled.article`
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	border-bottom: ${({ isLastArticle }) => !isLastArticle && `1px solid rgba(0,0,0,.2)`};
	border-top: ${({ isFirstArticle }) => isFirstArticle && '1px solid rgba(0,0,0,.2)'};
`

const ItemContainer = styled.div`
	padding-left: 1rem;
	padding-right: 1rem;
`

function AdditionalResources() {
	const { businessListings, searchTerm } = useContext(SearchContext)

	const data = businessListings[searchTerm] || []

	const resourceItems = data.map((listing, index) => {
		const isFirstArticle = index === 0
		const isLastArticle = index === data.length - 1

		return (
			<AdditionalResourceArticle
				key={`${listing.guid}${index}_rr`}
				isFirstArticle={isFirstArticle}
				isLastArticle={isLastArticle}
			>
				<ItemContainer>
					<AdditionalItem
						subtitle={`${listing.dek}`}
						title={listing.title}
						url={listing.canonical}
						displayUrl={listing.data.display_link}
					/>
				</ItemContainer>
			</AdditionalResourceArticle>
		)
	})

	return <ResourceSection>{resourceItems}</ResourceSection>
}

export default AdditionalResources
